import 'ui-core/plugins/tabs/js/tabs'; // BS v3 tabs
import 'ui-core/components/tabs/js/tabs';

(function () {
    UX.tab = UX.tab || {};
    UX.tab.vPort = 'screen-sm';

    if (config.enableTabsTypeDropdown) {
        UX.tab.on.select.dropdown = function (elem) {
            const dataAttr = elem.closest('ul').data('mobile-toggle');
            if (dataAttr === 'dropdown' || elem.closest('ul').hasClass('dropblock--tab')) {
                const dropdownContainer = elem.closest('.dropBlock');
                const newText = elem.text();
                dropdownContainer.children('a').attr('aria-label', newText).find('span').text(newText);
            }
        };
        UX.tab.on.dropdownBuild = function (elem, index) {
            // rebuild tabs to be as drop down
            if (UX.dropBlock) {
                UX.dropBlock.init();
            }

            elem.wrap('<div class="dropBlock" data-db-parent-of="dbTab-' + index + '"></div>');

            const $dropdownContainer = elem.closest('.dropBlock');
            const $activeTab = elem.find('.active a');

            $dropdownContainer.prepend(
                `<a href="#" class="dropBlock__link" data-db-target-for="dbTab-${index}" aria-label="${$activeTab.text()}">
                            <span aria-hidden="true">${$activeTab.text()}</span>
                            <i class="icon-arrow_d_n" aria-hidden="true"></i>
                        </a>`
            );
            elem.attr('data-db-target-of', 'dbTab-' + index);
        };
    }
})();
